
import { useEffect, useState } from "react";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import CatalogListGrid from "../../../common/catalog/CatalogListGrid";
import { catalogPageParams } from "../../../common/catalog/catalogPageSize";
import Paginator from "../../../common/paginator/Paginator";
import Skeleton from "../../../common/loading/Skeleton";
import Webinar from "../common/Webinar";

export default function MyWebinarSection({ isDesktop }) {
	const [webinars, setWebinars] = useState([]);
	const [page, setPage] = useState(1);
	const [maxPageNum, setMaxPageNum] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		fetchWebinars();
	}, []);

	useEffect(() => {
		fetchWebinars();
	}, [page]);

	function fetchWebinars() {
		if (isLoading) {
			return;
		}
		setIsLoading(true);
		api.webinarListMine({
			token: LoginHelper.getToken(),
			...catalogPageParams(page),
		}).then((result) => {
			setWebinars(result['webinars']);
			setMaxPageNum(result['max_page']);
			setIsLoading(false);
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		})
	}

	return (
		<div>
			<div className="font-Vazir-700 text-[16px] text-[#666666] mb-2">وبینارهای من</div>
			{isLoading && webinars.length === 0 && <Skeleton variant="grid" type="webinar" count={4} />}
			<CatalogListGrid isDesktop={isDesktop}>
				{webinars && !isLoading && (
					<>
						{webinars.length >= 1 ? (
							<>
								{webinars.map(webinar => (
									<Webinar key={webinar.id} webinar={webinar} />
								))}
							</>
						) : (
							<div className="text-[#666666] font-Vazir-400 text-[14px]">
								شما هیچ وبیناری ندارید.
							</div>
						)}
					</>
				)}
			</CatalogListGrid>
			{webinars.length >= 1 && maxPageNum >= 2 && (
				<>
					<div className="spacer p-[20px]"></div>
					<div className="flex flex-row justify-center">
						<Paginator currentPage={page} maxPageNum={maxPageNum} isLoading={isLoading} onChange={(newPage) => { setPage(newPage) }} />
					</div>
				</>
			)}
			{errorMessage && (
				<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
			)}
		</div>
	)
}
